import { render, staticRenderFns } from "./subStoreFreSetting.vue?vue&type=template&id=814e5b56&"
import script from "./subStoreFreSetting.vue?vue&type=script&lang=js&"
export * from "./subStoreFreSetting.vue?vue&type=script&lang=js&"
import style0 from "./subStoreFreSetting.vue?vue&type=style&index=0&id=814e5b56&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports